import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_GETALLUSERGLOBALFILTER } from "../../../utils/constants";
import { UserGlobalFilter } from "../../../models/UserModel/UserGlobalFilter";
import userGlobalFilterService from "../../../services/userService/userGlobalFilterService";
import ToastMessage from "../../../common/ToastMessage";

interface RemoveUserGlobalFilterContext {
  previousGlobalFilter: UserGlobalFilter[];
  deletedGlobalFilter: UserGlobalFilter | undefined;
}

const useRemoveUserGlobalFilter = (userId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string, RemoveUserGlobalFilterContext>({
    mutationFn: userGlobalFilterService.RemoveGlobalFilter,

    onMutate: (globalFilterId: string) => {
      const previousGlobalFilter =
        queryClient.getQueryData<UserGlobalFilter[]>([
          CACHE_KEY_GETALLUSERGLOBALFILTER,
          userId,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<UserGlobalFilter[]>(
        [CACHE_KEY_GETALLUSERGLOBALFILTER, userId],
        previousGlobalFilter.filter(
          (globalFilter) => globalFilter.id !== globalFilterId
        )
      );

      return {
        previousGlobalFilter,
        deletedGlobalFilter: previousGlobalFilter.find(
          (globalFilter) => globalFilter.id === globalFilterId
        ),
      };
    },

    onError: (error, globalFilterId, context) => {
      if (!context) return;

      ToastMessage.Failed(error.message);

      // Rollback to the previous state in case of error
      queryClient.setQueryData<UserGlobalFilter[]>(
        [CACHE_KEY_GETALLUSERGLOBALFILTER, userId],
        context.previousGlobalFilter
      );
    },

    onSuccess: () => {
      ToastMessage.Success();
    },
  });
};

export default useRemoveUserGlobalFilter;
